var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.575 10.225C19.575 9.56671 19.5167 8.94171 19.4167 8.33337H10V12.0917H15.3917C15.15 13.325 14.4417 14.3667 13.3917 15.075V17.575H16.6083C18.4917 15.8334 19.575 13.2667 19.575 10.225Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 20C12.7 20 14.9583 19.1 16.6083 17.575L13.3916 15.075C12.4916 15.675 11.35 16.0417 9.99995 16.0417C7.39162 16.0417 5.18329 14.2833 4.39162 11.9083H1.07495V14.4833C2.71662 17.75 6.09162 20 9.99995 20Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39167 11.9083C4.18333 11.3083 4.075 10.6666 4.075 9.99993C4.075 9.33327 4.19167 8.6916 4.39167 8.0916V5.5166H1.075C0.391666 6.8666 0 8.38327 0 9.99993C0 11.6166 0.391666 13.1333 1.075 14.4833L4.39167 11.9083Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 3.95833C11.475 3.95833 12.7916 4.46667 13.8333 5.45834L16.6833 2.60833C14.9583 0.991667 12.7 0 9.99995 0C6.09162 0 2.71662 2.25 1.07495 5.51667L4.39162 8.09167C5.18329 5.71667 7.39162 3.95833 9.99995 3.95833Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.35a2f1eb19c65f0020b607ecce888b7b.svg";
export { ForwardRef as ReactComponent };